import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { imgType } from 'types';
import styles from './awardsSection.css';

const localAwards = [
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
  {
    img: { src: '/images/lions.svg', hover: '/images/lionsHover.svg' },
    colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  },
];

const Link = styled.a`
  background-color: ${({ bgColor }) => bgColor};
`;

const Overlay = styled.div`
  background-color: ${({ bgColor }) => bgColor};
`;

class Award extends React.Component {
  state = { active: false };
  activateHover = () => {
    if (this.props.img.hover) {
      this.setState({ active: true });
    }
  };

  deactivateHover = () => {
    this.setState({ active: false });
  };
  render() {
    const { href, img, colors } = this.props;
    const { active } = this.state;
    return (
      <Link
        bgColor={colors.idle}
        onMouseEnter={this.activateHover}
        onMouseLeave={this.deactivateHover}
        onFocus={this.activateHover}
        onBlur={this.deactivateHover}
        className={styles.awardLink}
        href={href || undefined}
      >
        <Overlay
          className={active ? styles.overlayActive : styles.overlay}
          bgColor={colors.active}
        />
        <img
          width={75}
          height={75}
          className={active ? styles.awardImgHoverActive : styles.awardImgHover}
          src={img.hover}
          alt={img.alt}
        />
        <img
          width={75}
          height={75}
          className={active ? styles.awardImgActive : styles.awardImg}
          src={img.src}
          alt={img.alt}
        />
      </Link>
    );
  }
}

Award.defaultProps = {
  img: { src: '', hover: '' },
  colors: { active: '#a3e9f7', idle: '#4a5a7c' },
  href: '',
};

// prop-types for Award
const awardType = T.shape({
  href: T.string.isRequired,
  img: imgType.isRequired,
});

Award.propTypes = awardType.isRequired;

const typesMap = {
  clients: 'Клиенты',
  awards: 'Награды',
};

const Awards = ({ data, height, type }) => (
  <section className={styles.awardsWrapper}>
    <h2 className={styles.title}>{typesMap[type]}</h2>
    <div className={styles[type]}>
      {data.map((award, i) => <Award key={i} {...award} />)}
    </div>
  </section>
);

export default Awards;



// WEBPACK FOOTER //
// ./src/components/modules/AwardsSection/AwardsSection.js